import React from 'react';
import { Navigate, Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import UnregisterPageRoute from 'app/routes/settings/account/UnregisterPageRoute';

const basePath = '/v2/settings';

export default (
  <Route
    path={basePath}
    element={
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    }
  >
    <Route index element={<Navigate replace to={`${basePath}/account`} />} />
    <Route path={`${basePath}/account`} element={<Navigate replace to={`${basePath}/account/unregister`} />} />
    <Route path={`${basePath}/account/unregister/*`} element={<UnregisterPageRoute />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
